import { LoyaltyParamsService } from './../../../../services/loyalty/params.service';
import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { LoyaltyCardDefinitionService } from '../../../../services/loyalty/loyalty-card-definition.service';
import { LoyaltyChannelService } from '../../../../services/loyalty/loyalty-channel.service';
import { LoyaltyClusterService } from '../../../../services/loyalty/loyalty-cluster.service';
import { Observable } from 'rxjs/Observable';
import { CardDefinition } from '../../../../models/loyalty-card-definition.model';
import { KoncentroValidators } from '../../../../modules/UIKit/validators/koncentro-validators';

@Component({
  selector: 'app-form-card-definition-loyalty',
  templateUrl: './form-card-definition-loyalty.component.html',
  styleUrls: ['./form-card-definition-loyalty.component.css']
})
export class FormCardDefinitionLoyaltyComponent implements OnInit {

  fields: any;

  render = {
    channel: false,
    cluster: false,
    form: false
  }

  form: FormGroup;
  @Input() carddefId: string;
  @Input() editMode: boolean;
  channels: { value: string, label: string }[] = sessionStorage.getItem('cardDefChannels') ? JSON.parse(sessionStorage.getItem('cardDefChannels')) : [{value: null, label: ''}];
  clusters: { value: string, label: string }[] = sessionStorage.getItem('cardDefClusters') ? JSON.parse(sessionStorage.getItem('cardDefClusters')) : [{value: null, label: ''}];
  listTypeBarcode: { value: string, label: string }[] = sessionStorage.getItem('cardDefListTypeBarcode') ? JSON.parse(sessionStorage.getItem('cardDefListTypeBarcode')) : [{value: null, label: ''}];
  listTypeCard: { value: string, label: string }[] = sessionStorage.getItem('cardDefListTypeCard') ? JSON.parse(sessionStorage.getItem('cardDefListTypeCard')) : [{value: null, label: ''}];
  listTypeBalance: { value: string, label: string }[] = sessionStorage.getItem('cardDefListTypeBalance') ? JSON.parse(sessionStorage.getItem('cardDefListTypeBalance')) : [{value: null, label: ''}];
  listTypeBudget: { value: string, label: string }[] = sessionStorage.getItem('cardDefListTypeBudget') ? JSON.parse(sessionStorage.getItem('cardDefListTypeBudget')) : [{value: null, label: ''}];

  public invalidSubmit: boolean;
  public validators = {
    integerNotNegative: KoncentroValidators.integerNotNegative
  };

  constructor(
    private translate: TranslateService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private fb: FormBuilder,
    private cardDefService: LoyaltyCardDefinitionService,
    private channelService: LoyaltyChannelService,
    private clusterService: LoyaltyClusterService,
    private paramService: LoyaltyParamsService
  ) { }

  ngOnInit() {

    const paramBarcodeType = [
      {key: 'param_group', value: 'BarcodeType'}
    ];

    const paramCardType = [
      {key: 'param_group', value: 'CardType'}
    ];

    const paramBalanceType = [
      {key: 'param_group', value: 'BalanceType'}
    ];
    /*
    const paramBudgetType = [
      {key: 'param_group', value: 'BudgetType'}
    ];
    */
    let CardTypeList: Observable<any>;
    if (!sessionStorage.getItem('cardDefListTypeCard')) {
      CardTypeList =  this.paramService.list(null, null, paramCardType);
    }

    let BarcodeTypeList: Observable<any>;
    if (!sessionStorage.getItem('cardDefListTypeBarcode')) {
      BarcodeTypeList =  this.paramService.list(null, null, paramBarcodeType);
    }

    let BalanceTypeList: Observable<any>;
    if (!sessionStorage.getItem('cardDefListTypeBalance')) {
      BalanceTypeList =  this.paramService.list(null, null, paramBalanceType);
    }

    /*
    let BudgetTypeList: Observable<any>;
    BudgetTypeList =  this.paramService.list(null, null, paramBudgetType);
    */

    this.cardDefService.getFields().subscribe(res => {
      this.fields = res;
    });

    this.carddefId = this.activatedRoute.snapshot.params['carddefId'];
    this.editMode = (typeof this.carddefId !== 'undefined');
    let cardDef: Observable<any>;

    if (!this.editMode) {
      cardDef = Observable.of(new CardDefinition());
    } else {
      cardDef = this.cardDefService.get(this.carddefId);
    }

    if (CardTypeList && BarcodeTypeList && BalanceTypeList) {
      Observable.zip(
        CardTypeList,
        BarcodeTypeList,
        BalanceTypeList,
        // BudgetTypeList
        ).subscribe(([
          resCardTypeList,
          resBarcodeTypeList,
          resBalanceTypeList
          // resBudgetTypeList
        ]) => {

          for (const singleCardType of resCardTypeList.data) {
            this.listTypeCard.push({
              label: singleCardType.description,
              value: singleCardType.id
            });
          }
          sessionStorage.setItem('cardDefListTypeCard', JSON.stringify(this.listTypeCard));

          for (const singleBarcodeType of resBarcodeTypeList.data) {
            this.listTypeBarcode.push({
              label: singleBarcodeType.description,
              value: singleBarcodeType.id
            });
          }
          sessionStorage.setItem('cardDefListTypeBarcode', JSON.stringify(this.listTypeBarcode));

          for (const singleBalanceType of resBalanceTypeList.data) {
            this.listTypeBalance.push({
              label: singleBalanceType.description,
              value: singleBalanceType.id
            });
          }
          sessionStorage.setItem('cardDefListTypeBalance', JSON.stringify(this.listTypeBalance));

      });
    }

    if (!sessionStorage.getItem('cardDefChannels')) {
      this.channelService.list().subscribe(
        res => {
          for ( const channel of res.data) {

            this.channels.push(
              {
                label: channel.channelDescription,
                value: channel.id
              }
            );
          }

          this.render.channel = true;

        },
        error => console.error(error),
        () => sessionStorage.setItem('cardDefChannels', JSON.stringify(this.channels))
      );
    }

    if (!sessionStorage.getItem('cardDefClusters')) {
      this.clusterService.list(null, 9999999, null, null, null, null, '0').subscribe(
        res => {
          for ( const cluster of res.data) {
            this.clusters.push(
              {
                label: cluster.description,
                value: cluster.id
              }
            );
          }

          this.render.cluster = true;
        },
        error => console.error(error),
        () => sessionStorage.setItem('cardDefClusters', JSON.stringify(this.clusters))
      );
    }

    cardDef.subscribe((res) => {

    this.form = this.fb.group({
      channel_id: [res.channel_id || null],
      card_prefix: [res.card_prefix || null],
      card_suffix: [res.card_suffix || null],
      cluster_id: [res.cluster_id || null],
      card_lenght: [res.card_lenght || null],
      range_min: [res.range_min || null],
      range_max: [res.range_max || null],
      barcode_type_pid: [res.barcode_type_pid || null],
      card_loyalty_type_pid: [res.card_loyalty_type_pid || null],
      description: [res.description || null],
      balance_type_gen: [res.balance_type_gen || null],
      balance_type_req: [res.balance_type_req || null],
      flg_std_promo_cnf: [(res.flg_std_promo_cnf === '0') ? false : res.flg_std_promo_cnf],
      flg_point_acc: [(res.flg_point_acc === '0') ? false : res.flg_point_acc],
      flg_points_fru: [(res.flg_points_fru === '0') ? false : res.flg_points_fru]
    });

    this.render.form = true;

    });
  }

  save() {
    if (!this.form.valid) {
      this.invalidSubmit = true;
      return;
    }
    this.invalidSubmit = false;
    const cafDef = new CardDefinition();
    cafDef.description = this.form.get('description').value;
    cafDef.channel_id = this.form.get('channel_id').value;
    cafDef.card_prefix = this.form.get('card_prefix').value;
    cafDef.card_suffix = this.form.get('card_suffix').value;
    cafDef.cluster_id = this.form.get('cluster_id').value;
    cafDef.card_lenght = this.form.get('card_lenght').value;
    cafDef.range_min = this.form.get('range_min').value;
    cafDef.range_max = this.form.get('range_max').value;
    cafDef.barcode_type_pid = this.form.get('barcode_type_pid').value;
    cafDef.card_loyalty_type_pid = this.form.get('card_loyalty_type_pid').value;
    cafDef.balance_type_gen = this.form.get('balance_type_gen').value;
    cafDef.balance_type_req = this.form.get('balance_type_req').value;
    cafDef.flg_std_promo_cnf = (this.form.get('flg_std_promo_cnf').value) ? 1 : 0;
    cafDef.flg_point_acc = (this.form.get('flg_point_acc').value) ? 1 : 0;
    cafDef.flg_points_fru = (this.form.get('flg_points_fru').value) ? 1 : 0;

    if (!this.editMode) {
      this.cardDefService.create(cafDef).subscribe(res => {
        this.router.navigate(['/loyalty/card_def']);
      });
    }else {
      cafDef.id = this.carddefId;
      this.cardDefService.update(cafDef).subscribe(res => {
        this.router.navigate(['/loyalty/card_def']);
      });
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/views/loyalty/loyalty-card-definition/form-card-definition-loyalty/form-card-definition-loyalty.component.ts